import { useContext } from "react";
import { AlertContext } from "../contexts/AlertContext";

/**
 * useAlerts — hook para acessar os alertas globais.
 */
export const useAlerts = () => useContext(AlertContext);
